/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeatureTypeRequestMultiple } from '../../models/feature-type-request-multiple';

export interface InfoClickMultiple$Plain$Params {
      body?: FeatureTypeRequestMultiple
}

export function infoClickMultiple$Plain(http: HttpClient, rootUrl: string, params?: InfoClickMultiple$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, infoClickMultiple$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

infoClickMultiple$Plain.PATH = '/NetDb/InfoClickMultiple';
